export const DETAILS_BG = 'project-details-bg';
